module.exports = __webpack_public_path__ + "static/images/containers/ShopView/images/big/package_s.9d60221e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ShopView/images/big/package_s.png
// module id = 988
// module chunks = 16